export default __webpack_public_path__ + "823a6d210ac9bfe45a097f893d2e5a0f.jpg";